import { useState } from "react";
import { BadgePercent, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const DealsSignup = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email && !phone) { toast.error("Enter an email or phone number"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/deals/signup", {
        email: email || null, phone: phone || null,
        channel: email && phone ? "both" : email ? "email" : "sms",
      });
      setDone(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <section className="mx-auto max-w-7xl px-6 my-20" data-testid="deals-signup">
      <div className="rounded-3xl glass p-8 md:p-12 grid md:grid-cols-2 gap-8 items-center">
        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 text-primary font-semibold text-sm"><BadgePercent className="h-5 w-5" /> Exclusive Deals</div>
          <h2 className="font-head text-3xl font-extrabold">Get $50 off + insider deals</h2>
          <p className="text-muted-foreground">Sign up and we'll text or email you fresh deals every few days. New customers instantly unlock $50 off their first order.</p>
        </div>
        {done ? (
          <div className="text-center p-6 rounded-2xl bg-primary/10" data-testid="deals-success">
            <p className="font-head text-xl font-bold text-primary">You're in! 🎉</p>
            <p className="text-sm text-muted-foreground mt-1">Use code <span className="font-mono font-bold">WELCOME50</span> for $50 off.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="deals-form">
            <input data-testid="deals-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com" className="w-full bg-secondary rounded-xl px-4 h-12 outline-none focus:ring-2 ring-primary" />
            <input data-testid="deals-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone (optional, for SMS deals)" className="w-full bg-secondary rounded-xl px-4 h-12 outline-none focus:ring-2 ring-primary" />
            <button data-testid="deals-submit" disabled={busy}
              className="w-full rounded-xl bg-primary text-primary-foreground h-12 font-semibold hover:brightness-110 transition-[filter] flex items-center justify-center gap-2">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Claim $50 Off
            </button>
          </form>
        )}
      </div>
    </section>
  );
};
